import CustomFieldDataType from "@mapmycustomers/shared/enum/CustomFieldDataType";
import CustomField from "@mapmycustomers/shared/types/customField/CustomField";

const isDataTypeOptionable = (dataType: CustomField["dataType"]) =>
  [CustomFieldDataType.MULTI_OPTION, CustomFieldDataType.SINGLE_OPTION].includes(dataType);

export default isDataTypeOptionable;
